import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { CostsPerEmployee } from '../../../models/cost-per-employee';
import { CostsPerEmployeeType } from '../../../models/cost-per-employee-type';
import { findCostsPerEmployeeCatalogAct, saveCostsPerEmployeeCatalogAct, updateCostsPerEmployeeCatalogAct } from '../../../store/cost-per-employee-catalog/cost-per-employee-catalog.action';
import { findCostsPerEmployeeTypeCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';

@Component({
  selector: 'app-cost-per-employee-add',
  standalone: false,
  templateUrl: './cost-per-employee-add.component.html',
  styleUrl: './cost-per-employee-add.component.css'
})
export class CostPerEmployeeAddComponent {


  costsPerEmployeeCatForm!: NgForm;
  loading = false;
  title!: string;
  costsPerEmployee: CostsPerEmployee = new CostsPerEmployee();
  violations: any;
  costsPerEmployeeTypes: CostsPerEmployeeType[] = [];

  constructor(
    private route: ActivatedRoute,
    private costsPerEmployeeStore: Store<{costsPerEmployeeCatalogRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>
  ) {
    this.costsPerEmployeeStore.pipe(
      select('costsPerEmployeeCatalogRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        costsPerEmployee: state.costsPerEmployee,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ costsPerEmployee, violations, loading }) => {
      //this.costsPerEmployee = costsPerEmployee;
      this.costsPerEmployee = JSON.parse(JSON.stringify(costsPerEmployee));
      this.violations = violations;
      this.loading = loading;
      this.title = 'Detalles de Benefico';

      if(this.costsPerEmployeeCatForm){
      
        Object.keys(this.costsPerEmployeeCatForm.controls).forEach(controlName => {
          const control = this.costsPerEmployeeCatForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        costsPerEmployeeTypes: state.costsPerEmployeeTypes
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ costsPerEmployeeTypes }) => {
      //this.costsPerEmployeeTypes = costsPerEmployeeTypes;
      this.costsPerEmployeeTypes = JSON.parse(JSON.stringify(costsPerEmployeeTypes));
    });

  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.costsPerEmployeeStore.dispatch(findCostsPerEmployeeCatalogAct({ id }));
      }else{
        this.costsPerEmployee = new CostsPerEmployee();
        this.costsPerEmployee.active = true;
        this.loading = false;
        this.title = 'Agregar Beneficio';
      }
    });

    this.catalogOfferStore.dispatch(findCostsPerEmployeeTypeCatalogAct());
  }

  onSubmitBenefir(costsPerEmployeeCatForm: NgForm): void {
    //this.loading = true;
    this.costsPerEmployeeCatForm = costsPerEmployeeCatForm;
    const costsPerEmployeeCopy = JSON.parse(JSON.stringify(this.costsPerEmployee));
   
    if (costsPerEmployeeCopy.id > 0) {
      this.costsPerEmployeeStore.dispatch(updateCostsPerEmployeeCatalogAct({ costsPerEmployeeUpdated: costsPerEmployeeCopy }))
    } else {
      this.costsPerEmployeeStore.dispatch(saveCostsPerEmployeeCatalogAct({ costsPerEmployeeNew: costsPerEmployeeCopy }))
    }
  }

  compareCostsPerEmployeeTypes = (a: any, b: any) => a?.id === b?.id;
  removeSpaces() {
    this.costsPerEmployee.attribute = (this.costsPerEmployee.attribute ?? '').replace(/\s+/g, '');
  }  
}
